export enum FormStatus {
    InProgress,
    Complete,
};

export const FormStatusLabel: { [key in FormStatus]: string } = {
    [FormStatus.InProgress]: 'In Progress',
    [FormStatus.Complete]: 'Complete',
};